import { useQuery } from '@tanstack/react-query';
import { useCallback } from 'react';
import { curatorQueries } from '../../query-factory';
import { isSeedingItemUnviewed, type SeedingUnviewedWatermark } from './seedingUnviewedWatermark';
import { useSeedingWatermark } from './useSeedingWatermark';

const STORAGE_KEY = 'curator:collab:brands-proposal:last-viewed-at';

export const useBrandsProposalUnviewed = () => {
  // mount + 재가시마다 watermark 재독 — 목록 웹뷰에서 확인 후 me 페이지 dot 잔존 방지. (CMQA-7180 동류)
  const { mounted, seen, setSeen } = useSeedingWatermark(STORAGE_KEY);

  const { data } = useQuery({
    ...curatorQueries.campaigns.seedingMeProposalLatestPending(),
    enabled: mounted,
    staleTime: 60_000,
  });

  const latest = data?.list?.[0] ?? null;

  // 제안 받은 캠페인(시딩 PENDING) 0건이면 진입 이력과 무관하게 미노출. (SID-4120)
  // createdAt 동형 비교 watermark 로 '공백+KST' vs toISOString 이종 비교 결함 제거. (QAT-39429)
  const hasUnviewed = mounted && isSeedingItemUnviewed(latest, seen);

  const markAsViewed = useCallback(() => {
    if (latest == null) return; // PENDING 0건이면 watermark 를 덮지 않는다.
    const next: SeedingUnviewedWatermark = {
      id: latest.participationId,
      createdAt: latest.createdAt,
    };
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch {}
    setSeen(next);
  }, [latest, setSeen]);

  return { hasUnviewed, markAsViewed };
};
